export const SET_OPERATION_PROPERTY = 'SET_OPERATION_PROPERTY';
export const UPDATE_OPERATION_DATA = 'UPDATE_OPERATION_DATA';
export const SET_PATCH_OPERATION_FIELD = 'SET_PATCH_OPERATION_FIELD';
export const PROSPECT_TRANSFORM_PATCH_OPERATION = 'PROSPECT_TRANSFORM_PATCH_OPERATION';
export const UPDATE_OPERATION_PROSPECT_TO_BBVA = 'UPDATE_OPERATION_PROSPECT_TO_BBVA';
